import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { products } from '../../mock/mockData';
import { navigation, aboutSubpages, productIconMap } from './navData';

export const DesktopNav = ({ isActive }) => (
  <div className="hidden lg:flex lg:items-center lg:space-x-1">
    {navigation.map((item) => {
      if (item.hasDropdown) {
        const isAbout = item.hasDropdown === 'about';
        const items = isAbout ? aboutSubpages : products;
        const basePath = isAbout ? '/haqqimizda' : '/mehsullar';
        const testidPrefix = isAbout ? 'about' : 'products';
        return (
          <div key={item.name} className="relative group" data-testid={`${testidPrefix}-dropdown-trigger`}>
            <button
              type="button"
              className={`flex items-center gap-1 rounded-lg px-3 xl:px-4 py-2 text-sm font-medium transition-colors ${
                isActive(item.href)
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              {item.name}
              <ChevronDown className="h-4 w-4 transition-transform group-hover:rotate-180" />
            </button>
            <div className="absolute top-full left-0 right-0 h-2"></div>
            <div
              className="absolute top-[calc(100%+0.5rem)] left-0 w-72 bg-white border border-gray-200 rounded-xl shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50"
              data-testid={`${testidPrefix}-dropdown-menu`}
            >
              <div className="p-2">
                {items.map((entry) => {
                  const Icon = isAbout ? entry.icon : productIconMap[entry.icon];
                  return (
                    <Link
                      key={entry.slug}
                      to={`${basePath}/${entry.slug}`}
                      className="flex items-start gap-3 px-3 py-3 rounded-lg hover:bg-blue-50 transition-colors group/item"
                      data-testid={`dropdown-${testidPrefix}-${entry.slug}`}
                    >
                      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-50 group-hover/item:bg-blue-100 transition-colors flex-shrink-0">
                        <Icon className="h-4 w-4 text-blue-700" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-gray-900 group-hover/item:text-blue-700 transition-colors">{entry.title}</p>
                        <p className="text-xs text-gray-500 line-clamp-1">{entry.description}</p>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        );
      }
      return (
        <Link
          key={item.name}
          to={item.href}
          className={`rounded-lg px-3 xl:px-4 py-2 text-sm font-medium transition-colors ${
            isActive(item.href)
              ? 'bg-blue-50 text-blue-700'
              : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
          }`}
          data-testid={`nav-${item.href.replace('/', '') || 'home'}`}
        >
          {item.name}
        </Link>
      );
    })}
  </div>
);
